{
  "name": "angular-mileage",
  "version": "1.3.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "lint": "ng lint",
    "test": "ng test",
    "test:ci": "CHROME_BIN=$(node -e 'console.log(require(\"puppeteer\").executablePath())') ng test --watch=false --browsers=ChromeHeadless",
    "test:rules": "firebase emulators:exec \"npx -y tsx tests/firestore-rules.spec.ts\" --only firestore,auth",
    "emulators": "firebase emulators:start --only auth,firestore,functions --import=./data --export-on-exit",
    "emulators:clean": "firebase emulators:start --only auth,firestore,functions",
    "seed:users": "node tools/setup-local-test-users.js",
    "deploy": "firebase deploy --only hosting:mileage"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.4",
    "@angular/cdk": "^21.2.2",
    "@angular/common": "^21.2.4",
    "@angular/compiler": "^21.2.4",
    "@angular/core": "^21.2.4",
    "@angular/fire": "^21.0.0-rc.0",
    "@angular/forms": "^21.2.4",
    "@angular/material": "^21.2.3",
    "@angular/platform-browser": "^21.2.4",
    "@angular/router": "^21.2.4",
    "@angular/service-worker": "^21.2.4",
    "@fontsource/anton": "^5.3.0",
    "@fontsource/roboto": "^5.3.0",
    "firebase": "^12.10.0",
    "fuse.js": "^7.1.0",
    "material-icons": "^1.13.14",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.2",
    "@angular/cli": "^21.2.2",
    "@angular/compiler-cli": "^21.2.4",
    "@firebase/rules-unit-testing": "^5.0.1",
    "@types/jasmine": "~5.1.0",
    "angular-eslint": "^21.4.0",
    "eslint": "^9.39.5",
    "firebase-admin": "^14.4.0",
    "jasmine-core": "~5.9.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "puppeteer": "^24.40.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.67.0"
  }
}
